// import router from 'Router'
import { sortArrayByObjectKey } from 'Utils'
import alertActions from 'ServicesActions/alerts'

export const namespaced = true

export const state = {
  userAlerts: null,
}

export const mutations = {
  SET_ALERTS(state, payload) {
    state.userAlerts = payload
  },

  SET_ALERT_UPDATE(state, payload) {
    payload.alert.is_active = payload.status.is_active
  },
}

export const actions = {
  async load({ commit }) {
    try {
      const alerts = await alertActions.get.all()
      const sortedAlerts = await sortArrayByObjectKey(alerts.data, 'created', true)
      commit('SET_ALERTS', sortedAlerts)
      return alerts
    } catch (error) {
      console.error(error.message)
    }
  },

  async update(context, { id, status }) {
    try {
      const alertUpdate = await alertActions.update.alert(id, status)
      const updateInfo = {
        status,
        alert: context.getters.getAlert(id),
      }
      context.commit('SET_ALERT_UPDATE', updateInfo)
      // context.dispatch('cards/getCards', null, { root: true })

      // if (router.currentRoute.matched.some((r) => r.name === 'dashboard-client')) {
      //   const clientId = router.currentRoute.params.account_id
      //   context.dispatch('client/load', clientId, { root: true })
      // }
      return alertUpdate
    } catch (error) {
      console.error(error.message)
    }
  },
}

export const getters = {
  getAlert(state) {
    return (id) => {
      return state.userAlerts.filter((a) => a.id == id)[0]
    }
  },

  getActivityAlert(state) {
    return (activityId) => {
      return state.userAlerts.filter((alert) => alert.activity.id == activityId)[0]
    }
  },

  userHasAlerts(state) {
    return state.userAlerts?.some((alert) => alert.is_active)
  },
}
